"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("./context");
const headerClass = (0, nano_theme_1.rule)({
    fls: '0',
    pos: 'absolute',
    top: 0,
    l: 0,
    r: 0,
    z: 20,
});
const Header = ({ children, className, style, ...rest }) => {
    const state = (0, context_1.useScrollArea)();
    const ref = React.useRef(null);
    React.useLayoutEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        const observer = new ResizeObserver((entries) => {
            const entry = entries[0];
            if (entry)
                state.headerHeight$.next(entry.contentRect.height);
        });
        observer.observe(el);
        state.headerHeight$.next(el.offsetHeight);
        return () => {
            observer.disconnect();
            state.headerHeight$.next(0);
        };
    }, [state]);
    return (React.createElement("div", { ...rest, ref: ref, className: headerClass + (className ? ' ' + className : ''), style: style }, children));
};
exports.Header = Header;
